import { Banner } from '../../../hexagon/models/BannerModel';
import { AppState, FetchStatus } from '../../../redux/appState';

export interface BannerVM {
    status: FetchStatus;
    data: Banner;
    exists: boolean;
}

export const getBannerSelector = (state: AppState): BannerVM => ({
    status: state.banner.status,
    data: state.banner.data,
    exists: Object.keys(state.banner.data).length !== 0,
});
